import axios from 'axios'

export const BASE_URL = 'https://api-jifen.sumer.money/api'
// export const BASE_URL = "http://builder.meter.io:3000/api"

export const getMonadtestEnergy = async (address) => {
  return await axios.get(`${BASE_URL}/airdrop/monadtest?address=${address}`)
}

export const getMonadtestEnergyByX = async (address, state, code, captchaToken) => {
  // return await axios.post(`${BASE_URL}/airdrop/monadtestByX?address=${address}&state=${state}&code=${code}`)
  return await axios.post(`${BASE_URL}/airdrop/monadtestByX`, {
    address,
    state,
    code,
    captchaToken,
  })
}
